module.exports = __webpack_public_path__ + "media/toolkits/COVID-phones-overlay-8caa92f3.png";